import apiClient from "../lib/api-client";

export interface NotificationItem {
  id: string;
  tenantId: string;
  userId: string | null;
  title: string;
  message: string;
  type: string;
  read: boolean;
  data: Record<string, unknown> | null;
  createdAt: string;
}

export interface NotificationListResponse {
  items: NotificationItem[];
  total: number;
}

export const notificationService = {
  async list(params?: {
    unreadOnly?: boolean;
    limit?: number;
    offset?: number;
    type?: string;
    from?: string;
    to?: string;
  }): Promise<NotificationListResponse> {
    const { data } = await apiClient.get("/notifications", { params });
    return data;
  },

  async getUnreadCount(): Promise<number> {
    const { data } = await apiClient.get("/notifications/unread-count");
    return data.count;
  },

  async markRead(id: string): Promise<void> {
    await apiClient.patch(`/notifications/${id}/read`);
  },

  async markAllRead(): Promise<void> {
    await apiClient.patch("/notifications/read-all");
  },
};
